import axios from "axios";


const apiClient = axios.create({
    baseURL: `${process.env.REACT_APP_GS_URL}`,
    headers: {
        "X-Gamesheet-Partner-ApiKey": process.env.REACT_APP_GS_API_KEY,
        "Content-Type": "application/json",
    },
});

const objToQueryString = (params) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            query.append(key, value);
        }
    });
    return query.toString();
};

export const fetchFromApi = async (endpoint, params = {}) => {
    try {
        const query = objToQueryString(params);
        const fullUrl = query ? `${endpoint}?${query}` : endpoint;
        const response = await apiClient({
            method: "GET",
            url: fullUrl,
        });
        return response.data;
    } catch (error) {
        console.error("API GET Error:", error);
        throw error;
    }
};
export const addImgSizeToUrl = (url, size) => {
    if (url?.toString().includes("imagedelivery.net")) {
        return url + "/" + size.toString();
    } else {
        return url;
    }
};